import { render, staticRenderFns } from "./NotificationsListItem.vue?vue&type=template&id=4ff2b464&scoped=true&"
import script from "./NotificationsListItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationsListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff2b464",
  null
  
)

export default component.exports